import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            spacing: 'xxsmall.base',
            as: 'section',
            gap: {
                base: 'xsmall.base',
                md: 'xsmall.md',
                lg: 'xsmall.lg',
                xl: 'xsmall.xl',
            },
        },
        sectionTitle: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        list: {
            as: 'ul',
            gap: {
                base: 'xxsmall.base',
                md: 'xxsmall.md',
                lg: 'xxsmall.lg',
                xl: 'xxsmall.xl',
            },
        },
        card: {
            as: 'li',
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {
                base: 'xsmall.base',
                md: 'xsmall.md',
                lg: 'xsmall.lg',
                xl: 'xsmall.xl',
            },
            border: 'small',
            borderColor: 'border.table',
            bg: 'background.base.under',
            borderRadius: 'large-1',
            padding: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            _focusVisible: {
                outline: 'none',
                boxShadow: '0 0 0 2px var(--chakra-colors-border-dark)',
            },
        },
        contentWrapper: {
            flexDir: 'row',
            width: '100%',
            justifyContent: 'space-between',
            gap: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
        },
        imageNameContainer: {
            flexDir: 'row',
            gap: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
        },
        imageWrapper: {
            ratio: 1,
            boxSize: remCalc(62),
            minW: remCalc(62),
            maxW: remCalc(62),
            bg: 'transparent',
            borderRadius: 'medium-1',
            overflow: 'hidden',
        },
        image: {
            width: '100%',
            height: '100%',

            objectFit: 'contain',
        },
        content: {
            flex: 1,
            gap: {
                base: 'xxxsmall-1.base',
                md: 'xxxsmall-1.md',
                lg: 'xxxsmall-1.lg',
                xl: 'xxxsmall-1.xl',
            },
            minW: 0,
        },
        name: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            noOfLines: 1,
            fontWeight: 'medium',
        },
        description: {
            textStyle: 'body-small',
            color: 'foreground.neutral.muted',
            fontWeight: 'normal',
            lineHeight: remCalc(18),
            minHeight: remCalc(18),
            noOfLines: 1,
        },
        nameRow: {
            flexDir: 'column',
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
        },
        priceRow: {
            alignItems: 'center',
            gap: remCalc(0),
        },
        currentPrice: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        listPrice: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
            textDecoration: 'line-through',
        },
        discount: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
        },
        checkboxWrapper: {
            minW: remCalc(16),
            maxW: remCalc(16),
            h: remCalc(16),
            pt: remCalc(3),
            ml: remCalc(30),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '.chakra-checkbox__control': {
                borderRadius: 'medium',
                border: 'small',
                borderColor: 'border.neutral.highlight',
            },
        },
    },
}
